import React from 'react'
import {connect} from '@modifi/redux'
import {useTranslation} from '@modifi/plugin-i18n'
import {selectAuthenticationUserName} from '@modifi/plugin-authentication'

import StatusFilter, {StatusFilterProps} from './StatusFilter'

type AssigneeFilterProps = Omit<StatusFilterProps, 'filterKey' | 'options'> & {
  loggedInUser?: string
}

const AssigneeFilter: React.FC<AssigneeFilterProps> = ({loggedInUser = '', ...restFilterProps}) => {
  const {t} = useTranslation('kartavya')

  return (
    <StatusFilter
      filterKey="filter.assignee"
      options={[
        {
          label: t('filters.assignee-filter.assign-to-me.label'),
          value: loggedInUser,
        },
      ]}
      {...restFilterProps}
    />
  )
}

const mapStateToProps = (
  state: Record<string, any>
): Pick<AssigneeFilterProps, 'loggedInUser'> => ({
  loggedInUser: selectAuthenticationUserName(state),
})

export default connect(mapStateToProps)(AssigneeFilter)
